import React from "react";
import * as styles from "./rules-editor-activatable-section.module.scss";
import RulesEditorSection from "./rules-editor-section";
import IconCircleAdd from "../../../dynamicicons/icon-circle-add";
import { classArr } from "../../../helper/style-helper";
import whitelabel from "../../../whitelabel";
import HoverTooltip from "../../../elements/hover-tooltip";

export interface RulesEditorActivatableSectionProps {
	className?: string;
	title: string;
	onActivate?: () => void;
	disabled?: boolean;
	disabledTooltip?: string;
}

export function RulesEditorActivatableSection(
	props: RulesEditorActivatableSectionProps,
) {
	return (
		<HoverTooltip
			wrapperClassName={styles.tooltipWrapper}
			tooltip={props.disabled ? props.disabledTooltip : undefined}
		>
			<RulesEditorSection
				className={classArr(
					props.className,
					styles.container,
					props.disabled && styles.containerDisabled,
				)}
				onClick={props.disabled ? undefined : props.onActivate}
			>
				<IconCircleAdd color={whitelabel.palette.secondary900} />

				<span className={styles.label}>{props.title}</span>
			</RulesEditorSection>
		</HoverTooltip>
	);
}
